import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

const propTypes = {
  hasCompletedContent: PropTypes.bool,
  lessonInProgress: PropTypes.bool,
  license: PropTypes.bool,
  requiresSubscription: PropTypes.bool,
  restartText: PropTypes.string,
  small: PropTypes.bool,
  startText: PropTypes.string,
  url: PropTypes.string.isRequired,
  isActiveForUser: PropTypes.bool.isRequired,
}

const defaultProps = {
  hasCompletedContent: false,
  lessonInProgress: false,
  license: null,
  requiresSubscription: null,
  restartText: 'Restart Lesson',
  small: false,
  startText: 'Start Lesson',
}

const ContentButton = ({
  hasCompletedContent,
  isActiveForUser,
  lessonInProgress,
  license,
  requiresSubscription,
  restartText,
  small,
  startText,
  url,
}) => {
  let className = 'uk-button'
  if (small) {
    className = `${className} uk-button-small`
  }

  if (
    (license === false && requiresSubscription === true) ||
    (requiresSubscription && !isActiveForUser)
  ) {
    return (
      <button
        className={className}
        style={{
          background: '#f8f8f8',
        }}
        type="button"
      >
        <span className="uk-margin-small-right" data-uk-icon="icon: lock; ratio: 0.7" />
        Locked
      </button>
    )
  }

  if (hasCompletedContent === true) {
    return (
      <Link
        className={className}
        style={{
          background: '#f8f8f8',
        }}
        to={url}
        type="button"
      >
        {restartText}
      </Link>
    )
  }

  if (lessonInProgress === true) {
    return (
      <Link
        className={className}
        style={{
          background: '#ffffff',
          border: '3px solid #1e87f0',
          color: '#1e87f0',
        }}
        to={url}
        type="button"
      >
        Continue
      </Link>
    )
  }

  return (
    <Link className={`${className} uk-button-primary`} to={url} type="button">
      {startText}
    </Link>
  )
}

ContentButton.propTypes = propTypes
ContentButton.defaultProps = defaultProps

export default ContentButton
